import { Trash2 } from "lucide-react";
import FormField from "../../components/FormField";
import IconButton from "../../components/IconButton";
import SearchSelect from "../../components/SearchSelect";
import TextInput from "../../components/TextInput";

const errorFor = (errors, path) => errors?.[path]?.[0] || "";

const COSSUser = (props) => {
  const userData = props.userData || {};
  const userIndex = props.userIndex;
  const valuePath = `users.cossusers.${userIndex}`;
  const options = (props.userOptions || []).map((user) => ({ label: user.name, value: user.id || user._id, user }));
  const selected = options.find((option) => option.value === userData.user_id) || null;
  const chooseUser = (option) => props.handleInputChange(valuePath, option ? { user_id: option.value, name: option.user.name, location: userData.location, tasks: userData.tasks, phone_no: option.user.phone_no } : {});

  return (
    <article className="wsm-pack-form-section__entry">
      <div className="wsm-pack-form-section__entry-heading"><h4>IWA/COSS user {userIndex + 1}</h4><IconButton aria-label={`Remove IWA/COSS user ${userIndex + 1}`} icon={Trash2} onClick={() => props.handleRemoveFormRow("users.cossusers", userIndex, true, "IWA/COSS user")} size="compact" variant="destructive" /></div>
      <div className="wsm-pack-form__field-grid wsm-pack-form__field-grid--four">
        <SearchSelect error={errorFor(props.errors, `data.users.cossusers.${userIndex}.name`)} id={`coss-name-${userIndex}`} isClearable label="IWA/COSS user" loading={props.usersLoading} onChange={chooseUser} options={options} placeholder="Select a person" required value={selected} />
        <FormField id={`coss-location-${userIndex}`} label="Location">{(fieldProps) => <TextInput {...fieldProps} onChange={(event) => props.handleInputChange(`${valuePath}.location`, event.target.value)} value={userData.location || ""} />}</FormField>
        <FormField id={`coss-tasks-${userIndex}`} label="Tasks">{(fieldProps) => <TextInput {...fieldProps} onChange={(event) => props.handleInputChange(`${valuePath}.tasks`, event.target.value)} value={userData.tasks || ""} />}</FormField>
        <FormField error={errorFor(props.errors, `data.users.cossusers.${userIndex}.phone_no`)} id={`coss-phone-${userIndex}`} label="Phone number" required>{(fieldProps) => <TextInput {...fieldProps} disabled value={userData.phone_no || ""} />}</FormField>
      </div>
    </article>
  );
};

export default COSSUser;